import Button from 'components/Button';
import MessageBox from 'components/MessageBox';
import ModalContainer from 'components/ModalContainer';

import orgService from "services/Auth.Organization.service";
import { messageKeyPrefix } from "utils/message.util";
import { uiActions } from "stores/slice/ui";

import { useState } from 'react';
import { useDispatch } from "react-redux";
import { useTranslation } from 'react-i18next';

const OrgManagementGenerateModal = ({
  info,
  modalStatus,
  handleModals
}) => {

  const { t } = useTranslation();
  const dispatch = useDispatch();
  const [messageBox, setMessageBox] = useState({ error: null });

  const closeModal = () => {
    setMessageBox({ error: null });
    // changeModalStatus('generate', false);
    handleModals({ modal: 'generate', status: false });
  };

  const generateList = async () => {
    try {
      dispatch(uiActions.showModalSpinner());
      await orgService.generateOrgReport(info.orgDs.id);
      if (orgService.hasError()) {
        setMessageBox({ error: t(`${messageKeyPrefix.e.s}${orgService.error.originCode}`) });
      } else {
        closeModal();
      }
    } catch (error) {
      console.error(error);
      setMessageBox({ error: t(`${messageKeyPrefix.e.s}${1000}`) });
    } finally {
      dispatch(uiActions.hideModalSpinner());
    }
  };

  return (
    <ModalContainer
      modalWidthType='modal-500px'
      openModal={modalStatus.generate.status}
      closeModal={() => closeModal()}
    >
      <div className='header'>
        <div className='title'>{t('7a981a2edd')}</div>
      </div>
      <div className='body'>
        <MessageBox
          show={!!messageBox.error}
          label={messageBox.error}
          variant="danger"
          onClose={() => {
            setMessageBox({ error: null });
          }}
        />
        <div className='mb-1'>{t('861747d4fd')}</div>
        <div className='mb-1'>{t('2c865c4880')}</div>
      </div>
      <div className='footer non-border-top-footer'>
        <Button
          label='Cancel'
          className='btn-cancel'
          onClick={() => closeModal()}
        />
        <Button
          label='Yes'
          className='btn-submit'
          onClick={() => { generateList(); }}
        />
      </div>
    </ModalContainer>
  );
};

export default OrgManagementGenerateModal;
